import { LockableAmountFieldMetadata, LockablePercentFieldMetadata } from 'models/forms/fields';
import { useCallback } from 'react';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

type LockableDigitFieldProps = LockablePercentFieldMetadata | LockableAmountFieldMetadata;

type LockableDigitFieldData = {
  value: Nullable<number>;
  customized: boolean;
};

export function useLockedDigitField(props: LockableDigitFieldProps) {
  const { id, isLocked, showValue } = props;
  const [value, setFormData] = useFormFieldData<Nullable<LockableDigitFieldData>>(id);

  const handleLockChanged = useCallback(
    (locked: boolean) => {
      if (value) {
        setFormData(locked ? null : { value: value.value, customized: true });
      } else {
        setFormData(locked ? null : { value: 0, customized: true });
      }
    },
    [value, setFormData],
  );

  return {
    value: value?.value ?? null,
    setFormData,
    showValue: showValue ?? true,
    isLocked,
    handleLockChanged,
  };
}
